module.exports = __webpack_public_path__ + "static/img/djkx8.ed78088.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/djkx8.jpeg
// module id = waXL
// module chunks = 1